import { memo } from "react";
import { AD_SIZES } from "./constants";

/**
 * Native ad
 *
 * @param {{
 *    position: string,  // Unique ID on page to allow adops to target specific positions
 *    className: string, // Allows layouts that use native ads to set CSS on the inner contents
 *  }} props
 */
function NativeAd({ position = null, className = "native-unset" }) {
  return (
    <gpt-ad
      suppressHydrationWarning={true}
      // Since this is a fake element, we don't use className
      // https://react.dev/reference/react-dom/components#custom-html-elements
      class={className}
      unitpath="native"
      // Theory of sizes: if it fits, it ships, may the highest price size win
      // Some mobile-specific formats on mobile
      // In the rare event DFP thinks the best thing to serve on desktop is a box,
      // trust the algorithm and serve a box.
      targeting-pos={position}
      id-format={AD_SIZES.NATIVE.idFormat}
      {...AD_SIZES.NATIVE.props}
    ></gpt-ad>
  );
}

// Never allow re-rendering
export default memo(NativeAd);
